import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexComponent } from './index/index.component';
import {propertyTaxRouting} from "./property-tax.routing";



@NgModule({
  declarations: [
    IndexComponent
  ],
  imports: [
    CommonModule,
    propertyTaxRouting
  ]
})
export class PropertyTaxModule { }
